import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface INewActivityUserRequest extends IBaseRequest {
    roleName?:      string;
    role?:          string;
    note?:          string;
    id?:            string;
    userId:         number;
    activityName?:  string;
    acl?:           string;
    activity:       number;
    isPrimary:      number;
    contact:        number;
    userName?:      string;
}

export class NewActivityUserRequest extends BaseRequest implements INewActivityUserRequest {

    public roleName?:       string;
    public role?:           string;
    public note?:           string;
    public id?:             string;
    public userId:          number;
    public activityName?:   string;
    public acl?:            string;
    public activity:        number;
    public isPrimary:       number;
    public contact:         number;
    public userName?:       string;

    constructor(server: string, session: string, 
        userId: number, activity: number, 
        isPrimary: number, contact:number, 
        otherOptions: any
    ) {
        super(server, session);

        this.roleName = otherOptions.roleName;
        this.role = otherOptions.role;
        this.note = otherOptions.note;
        this.id = otherOptions.id;
        this.userId = userId;
        this.activityName = otherOptions.activityName;
        this.acl = otherOptions.acl;
        this.activity = activity;
        this.isPrimary = isPrimary;
        this.contact = contact;
        this.userName = otherOptions.userName;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.roleName, 'roleName');
        parameters += this.makeNode(this.role, 'role');
        parameters += this.makeNode(this.note, 'note');
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.userId, 'userId');
        parameters += this.makeNode(this.activityName, 'activityName');
        parameters += this.makeNode(this.acl, 'acl');
        parameters += this.makeNode(this.activity, 'activity');
        parameters += this.makeNode(this.isPrimary, 'isPrimary');
        parameters += this.makeNode(this.contact, 'contact');
        parameters += this.makeNode(this.userName, 'userName');
        
        return super.wrapperXml('NewActivityUser', parameters);
    }
}
